import React, { useEffect, useState, useCallback } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import DataFunction from "../../../Functions/AllFunctions";
import SymptomCategoryServices from "../../../services/SymptomCategoryServices";
import UploadServices from "../../../services/UploadServices";
import { notifySuccess } from "../../../utils/toast";
import TableLoader from "../../../Reuseable/TableLoader";

const SymptomsCategories = () => {
  const [allCategories, setAllCategories] = useState([]);

  // Create Category States
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  const getData = useCallback(() => {
    SymptomCategoryServices.getAllCategory()
      .then((res) => setAllCategories(res?.data))
      .catch((err) => console.log(err.message));
  }, []);

  useEffect(() => {
    getData();
  }, []);

  const postData = (e) => {
    e.preventDefault();
    const body = {
      name: title,
      description: description,
    };
    SymptomCategoryServices.createCategory(body).then((res) => {
      getData();
      setTitle("");
      setDescription("");
    });
  };

  const deleteCategory = (e, id) => {
    e.preventDefault();
    SymptomCategoryServices.deleteCategory(id).then((res) => {
      notifySuccess("Category deleted");
      getData();
    });
  };

  const editCategory = (e, id) => {
    e.preventDefault();
    const body = {
      name: title,
      description: description,
    };
    SymptomCategoryServices.updateCategory(id, body).then((res) => {
      notifySuccess("Category Updated");
      getData();
      setIsEditing(false);
      setEditId("");
      setTitle("");
      setDescription("");
    });
  };

  const handelEditClick = (e, item) => {
    setIsEditing(true);
    setEditId(item?._id);
    setTitle(item?.name);
    setDescription(item?.description);
  };

  return (
    <>
      <Helmet>
        <title>Blog Categories - Emberace</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0">All Categories</h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to="/dashboard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">All Categories</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-4">
                <div className="card">
                  <div className="card-body">
                    <form
                      onSubmit={
                        isEditing === true
                          ? (e) => editCategory(e, editId)
                          : (e) => postData(e)
                      }
                    >
                      <div className="mb-3">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-12 col-form-label"
                        >
                          Title
                        </label>
                        <div className="col-md-12">
                          <input
                            required
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-12 col-form-label"
                        >
                          Description
                        </label>
                        <div className="col-md-12">
                          <textarea
                            rows={3}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            required
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <button
                          className="btn btn-primary"
                          type="submit"
                          style={{ width: "100%" }}
                        >
                          Submit form
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-8">
                <div className="card">
                  <div className="card-body">
                    {allCategories === undefined ||
                    allCategories === null ||
                    allCategories?.length === 0 ? (
                      <TableLoader />
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-striped mb-0">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Title</th>
                              <th>Description</th>
                              <th>Actions</th>
                            </tr>
                          </thead>

                          <tbody>
                            {allCategories &&
                              allCategories?.map((el, index) => (
                                <tr key={el?._id}>
                                  <th scope="row">{index + 1}</th>
                                  <td>{el?.name}</td>
                                  <td>{el?.description}</td>
                                  <td>
                                    <i
                                      className="mdi mdi-trash-can-outline iconsize"
                                      onClick={(e) => deleteCategory(e, el._id)}
                                    />
                                    <i
                                      className="mdi mdi-pencil-box-outline iconsize"
                                      onClick={(e) => handelEditClick(e, el)}
                                    />
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SymptomsCategories;
